module.exports = __webpack_public_path__ + "img/Card_heart_4.36cac6fc.svg";